import { render, staticRenderFns } from "./EditIdentifiants.vue?vue&type=template&id=285beef3&scoped=true&"
import script from "./EditIdentifiants.vue?vue&type=script&lang=js&"
export * from "./EditIdentifiants.vue?vue&type=script&lang=js&"
import style0 from "./EditIdentifiants.vue?vue&type=style&index=0&id=285beef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285beef3",
  null
  
)

export default component.exports